export class SignDetailLocation {
  rack: number;
  shelf: string;
  compartment: number;
}
